// extracted by mini-css-extract-plugin
export default {"purpose":"styles_purpose__AvGPx","amount":"styles_amount__O9NbZ","qr":"styles_qr__VymID","link":"styles_link__IZ-07"};